import { Action } from '@ngrx/store';
import { Event } from '../../models/calendar';
import { PayloadAction } from '@ipreo/muni-shared';

const CALENDAR_LOAD_REQUESTED = '[marketDrawer] Fetch Calendar';
const CALENDAR_LOAD_SUCCESS = '[marketDrawer] Fetch Calendar Success';
const CALENDAR_LOAD_FAILURE = '[marketDrawer] Fetch Calendar Error';
const CALENDAR_SHOW_EVENT = '[marketDrawer] Calendar Show Event';
const CALENDAR_HIDE_EVENT = '[marketDrawer] Calendar Hide Event';
const CALENDAR_TOGGLE_FULLSCREEN = '[marketDrawer] Calendar Toggle Fullscreen';
const CALENDAR_SEE_EVENT = '[marketDrawer] Calendar See Event';

/* tslint:disable:max-classes-per-file */
class CalendarLoadAction implements PayloadAction<Date> {
    public readonly type = CALENDAR_LOAD_REQUESTED;

    constructor(public payload: Date) {}
}

class CalendarLoadSuccessAction implements PayloadAction<Event[]> {
    public readonly type = CALENDAR_LOAD_SUCCESS;

    constructor(public payload: Event[]) {}
}

class CalendarLoadErrorAction implements PayloadAction<string> {
    public readonly type = CALENDAR_LOAD_FAILURE;

    constructor(public payload: string) {}
}

class CalendarShowEventAction implements PayloadAction<number> {
    public readonly type = CALENDAR_SHOW_EVENT;

    constructor(public payload: number) {}
}

class CalendarHideEventAction implements Action {
    public readonly type = CALENDAR_HIDE_EVENT;
}

class CalendarToggleFullscreenAction implements Action {
    public readonly type = CALENDAR_TOGGLE_FULLSCREEN;
}

class CalendarSeeEventAction implements Action {
    public readonly type = CALENDAR_SEE_EVENT;
}

type Actions =
    | CalendarLoadAction
    | CalendarLoadSuccessAction
    | CalendarLoadErrorAction
    | CalendarShowEventAction
    | CalendarHideEventAction
    | CalendarToggleFullscreenAction
    | CalendarSeeEventAction;

export {
    CALENDAR_LOAD_REQUESTED,
    CALENDAR_LOAD_SUCCESS,
    CALENDAR_LOAD_FAILURE,
    CALENDAR_SHOW_EVENT,
    CALENDAR_HIDE_EVENT,
    CALENDAR_TOGGLE_FULLSCREEN,
    CALENDAR_SEE_EVENT,
    Actions,
    CalendarLoadAction,
    CalendarLoadSuccessAction,
    CalendarLoadErrorAction,
    CalendarShowEventAction,
    CalendarHideEventAction,
    CalendarToggleFullscreenAction,
    CalendarSeeEventAction
};
